module.exports = __webpack_public_path__ + "img/friendly_reminders.718282d0.svg";